module.exports = __webpack_public_path__ + "static/media/bfenwick.46376807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/bfenwick.jpg
// module id = 709
// module chunks = 0